module.exports = __webpack_public_path__ + "img/item10.99863e7d.png";